<div class="h-screen flex flex-column flex-grow-1 bg-cover" style="background: url('assets/layout/images/pages/login-bg.jpg')">

    <div class="align-self-center mt-auto mb-auto">
        <div class="text-center z-5 flex flex-column border-1 border-round-md surface-border surface-card px-3">
            <br>
            <h4>eArhiv</h4>

            <div class="text-color-secondary mb-6 px-6">Molimo unesite svoje korisničko ime i zaporku za prijavu</div>
            <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit($event, loginForm.value)">
                <div class="w-full flex flex-column gap-3 px-3 pb-6" [ngClass]="{'field--not-empty': loginForm.get('username')?.value !== ''}">
                    <span class="p-input-icon-left">
                        <i class="pi pi-envelope"></i>
                        <input type="text" class="w-full" pInputText placeholder="Korisničko ime" [formControl]="loginFormControl('username')" autocomplete="username" />
                    </span>
                    <div *ngIf="loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched"
                        class="alert-message">
                        Korisničko ime je obavezno.
                    </div>
                    <span class="p-input-icon-left" [ngClass]="{'field--not-empty': loginForm.get('password')?.value !== ''}">
                        <i class="pi pi-key"></i>
                        <input type="password" class="w-full" pInputText placeholder="Zaporka" [formControl]="loginFormControl('password')" autocomplete="current-password" />
                    </span>
                    <div *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched"
                        class="alert-message">
                        Zaporka je obavezna.
                    </div>
                    <button pButton pRipple type="submit" class="w-full my-3 px-3" label="PRIJAVA" [disabled]="!loginForm.valid || submitted"></button>
                    <a class="w-full my-3 px-3" href="#" (click)="forgottenPassword($event)">Zaboravljena zaporka</a>
                </div>
            </form>
        </div>
    </div>
</div>

<!--<app-config [minimal]="true"></app-config>-->
